module.exports = __webpack_public_path__ + "static/media/arrow.2abac628.svg";